export enum InventoryGraphNodeCategory {
    resource = "resource",
    virtualNode = "virtualNode",
}
